// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Customer } from './customer';
import { MixStrength } from './mix-strength';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class CustomerMixStrengthLink extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get isLimestone() {
    return this.trimmedMixStrengthName.endsWith('+ls');
  }

  get trimmedMixStrengthName() {
    if (!this.mixStrength || !this.mixStrength.name) return '';

    return this.mixStrength.name.toLowerCase().replaceAll(' ', '');
  }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  created!: Date;
  createdBy?: string;
  customerId!: number;
  deleted?: Date;
  deletedBy?: string;
  mixStrengthId!: number;
  price!: number;
  customer!: Customer;
  mixStrength!: MixStrength;
}

